<div class="page">
    <div class="page-name">Manage Projects</div><br>
    <div class="row">
        <div class="col-12 col-lg-6">
            <div class="create-proj-sec">
                <div class="card-title">Create Project</div>
                <div class="card-content">
                    <div class="field">
                        <div class="field-label">Title</div>
                        <dx-text-box [readOnly]="disAdmin" stylingMode="outlined" class="field-value" placeholder="Enter new title" [(value)]="title" valueChangeEvent="input" (onValueChanged)="enableCreateTitle()">
                        </dx-text-box>
                    </div>
                    <div class="field">
                        <div class="field-label">Copy Title</div>
                        <div class="title-search-block field-value">
                            <p-autoComplete 
                #projectSearch
                appendTo="body"
                [baseZIndex]="1000"
                [(ngModel)]="selectedItem"
                [suggestions]="projectSearchList"
                [showEmptyMessage]="true"
                emptyMessage="No project found" 
                (completeMethod)="searchProjects($event)"
                field="title"
                [disabled]="disAdmin"
                [minLength]="2"
                styleClass="project-list-select"
                placeholder="Enter Title/AKA"
                (onSelect)="selectProj($event)"
                >
            </p-autoComplete>
                            
                            <!-- <dx-text-box #projectSearch class="project-list-select" [readOnly]="disAdmin"  stylingMode="outlined" placeholder="Enter title/AKA"
                                (onInput)="searchProjects($event)" [(value)]="selectedCopyProject.title"
                            >
                            </dx-text-box>
                            <dx-drop-down-box
                                class="title-dropdown"
                                [disabled]="disAdmin"
                                stylingMode="outlined"
                                [(opened)]="isProjectListDropDownOpened"
                                [(value)]="selectedCopyProject"
                                valueExpr="this"
                                displayExpr="title"
                                [dataSource]="this.projectSearchList"
                            >
                                <dx-list
                                    [dataSource]="projectSearchList"
                                    [noDataText]="noSearchResultText"
                                    displayExpr="title"
                                    valueExpr="projectId"
                                    selectionMode="single"
                                    (onItemClick)="selectProj($event)"
                                >
                                </dx-list>
                            </dx-drop-down-box> -->
                        </div>
                        
                    </div>
                    <dx-button [disabled]="disAdmin" *ngIf="enableCreate" class="rounded-pill" stylingMode="contained" text="Create" type="default"
                        (onClick)="confirmCreateProject()">
                    </dx-button>
                </div>
            </div>
        </div>
    </div>
    <div class="section">

        <div class="content-block pt-1">

            <div class="card-title">PROJECT LIST</div>

            <div class="d-flex w-100 flex-fill flex-row">
                <dx-data-grid 
                    class="grid-with-header"
                    [dataSource]="projectList"
                    [allowColumnResizing]="true" 
                    [columnResizingMode]="'widget'" 
                    [hoverStateEnabled]="true"
                    [rowAlternationEnabled]="true" 
                    [columnAutoWidth]="true" 
                    [allowColumnReordering]="true"
                    noDataText="No records found!"
                    keyExpr="projectId"
                    (onRowRemoving)="onProjectRowRemoving($event)"
                >
                    <dxo-scrolling mode="virtual" [showScrollbar]="'always'"></dxo-scrolling>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-editing mode="row" [allowDeleting]="isProjectDeleteAllowed" [useIcons]="true" width="10%"></dxo-editing>

                    <dxi-column caption="TITLE" dataField="title" width="20%"></dxi-column>
                    <dxi-column caption="STUDIO" dataField="studioId" width="10%">
                        <dxo-lookup [dataSource]="studioList" displayExpr="value" valueExpr="picklistDetailId">
                        </dxo-lookup>
                    </dxi-column>
                    <dxi-column caption="STATUS" dataField="projectStatusId" width="10%">
                        <dxo-lookup [dataSource]="statusList" displayExpr="value" valueExpr="picklistDetailId">
                        </dxo-lookup>
                    </dxi-column>
                    <dxi-column caption="CREATED BY" dataField="createdBy" width="10%"></dxi-column>
                    <dxi-column caption="CREATED DATE" dataField="createdDate" dataType="date"
                    format="MM/dd/yy" width="10%"></dxi-column>
                    <dxi-column caption="LAST MODIFIED BY" dataField="modifiedBy" width="10%"></dxi-column>
                    <dxi-column caption="LAST MODIFIED DATE" dataField="modifiedDate" dataType="datetime"
                    format="MM/dd/yy, HH:mm aa" width="10%"></dxi-column>
                </dx-data-grid>
            </div>

        </div>

    </div>
</div>
<app-confirmation-popup *ngIf="openConfirmationPopup" [option]="confirmationPopupOption"
    (onConfirmed)="confirmationChanges($event)"></app-confirmation-popup>